import * as apiUrl from "../../apiUrl";



export const fetchInvestInDubaiPageData = async () => {
  try {
    const endpoints = [
      "/api/investing-in-dubai/banner-section",
      "/api/investing-in-dubai/second-section",
      "/api/investing-in-dubai/third-section",
      "/api/investing-in-dubai/fourth-section",     
    ];

    const fetchPromises = endpoints.map(async (endpoint) => {
      const url = apiUrl.apiUrl + endpoint;
      const response = await fetch(url);
      if (!response.ok) {
        console.error(`Failed to fetch ${url}: Status ${response.status}`);
        throw new Error(`HTTP error ${response.status}`);
      }
      return response.json();
    });

    const [
      banner,
      second,
      third,
      fourth,      
    ] = await Promise.all(fetchPromises);

    return { banner, second, third, fourth };
  } catch (error) {
    console.error("Error fetching Invest In Dubai page data:", error);
    return null;
  }
};


